var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('img',{attrs:{"src":_vm.logo[_vm.type],"alt":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }